import { createSourcedAction } from '@ces/sourced-action';
import { props } from '@ngrx/store';
import { WatchListsState } from 'egov-api';

export const loadWatchListsState = createSourcedAction('Load watch lists state');
export const watchListsStateLoadFailed = createSourcedAction('Watch lists state load failed');
export const watchListsStateLoaded = createSourcedAction('Watch lists state loaded', props<{ newState: WatchListsState }>());
